module.exports = __webpack_public_path__ + "static/media/back-arrow-header.01811456.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hinkley/back-arrow-header.svg
// module id = 296
// module chunks = 0